<template>
    <div class="py-2">
      <label for="{{forLabel}}" class="block text-sm font-medium text-gray-700"><span v-if="required" class="text-rose-600">*</span> {{label}}</label>
      <div class="mt-1">
        <div class="flex flex-col w-full">
            <div class="flex w-full gap-2 text-xs pb-2">
                <div class="relative">
                  <div class="pb-1 pt-2">Cep:</div>

                  <div class="relative">
                    <input type="text" :name="fields[0].name" v-model="address.fields.zipcode" class="defaultInput pl-8" :class="name ? fieldsError[field_id] ? 'bg-rose-50' : '': ''"  @blur="getData">
                    <MapPinIcon class="absolute top-1.5 left-1 flex items-center text-gray-800 h-6 w-6" />
                  </div>
                </div>                
            </div>
            <div v-if="cepSearch" class="-m-1 bg-gray-100 p-2 rounded-md mt-1">
              <div class="flex w-full gap-2 text-xs rounded-t-lg">
                  <div class="w-[150px]">
                      {{ fields[1].label }}:
                      <input type="text" :name="fields[1].name" v-model="address.fields.state"  class="defaultInput" :class="name ? fieldsError[field_id] && address.fields.state == '' ? 'bg-rose-50' : '': ''">
                  </div>
                  <div>
                      {{ fields[2].label }}:
                      <input type="text" :name="fields[2].name" v-model="address.fields.locality" class="defaultInput" :class="name ? fieldsError[field_id] && address.fields.locality == '' ? 'bg-rose-50' : '': ''">
                  </div>    
                  <div>
                      {{ fields[3].label }}:
                      <input type="text" :name="fields[3].name" v-model="address.fields.neighborhood" class="defaultInput" :class="name ? fieldsError[field_id] && address.fields.neighborhood == '' ? 'bg-rose-50' : '': ''">
                  </div>                
              </div>
              <div class="flex w-full gap-2 text-xs pt-2 pb-2 rounded-b-lg">
                  <div  class="w-full">
                      {{ fields[4].label }}:
                      <input type="text" :name="fields[4].name" v-model="address.fields.publicplace" class="defaultInput" :class="name ? fieldsError[field_id] && address.fields.publicplace == '' ? 'bg-rose-50' : '': ''">
                  </div>
                  <div class="w-[110px]">
                      {{ fields[5].label }}:
                      <input type="text" :name="fields[5].name" v-model="address.fields.number" class="defaultInput"  :class="name ? fieldsError[field_id] && address.fields.number == '' ? 'bg-rose-50' : '': ''">
                  </div>    
                  <div>
                      {{ fields[6].label }}:
                      <input type="text" :name="fields[6].name" v-model="address.fields.complement" class="defaultInput">
                  </div>                
            </div>
          </div>
        </div>


      </div>
    </div>
    
  </template>
  
  <script>

import { MapPinIcon } from '@heroicons/vue/24/solid';

  
  export default {
      name: 'Address',
      props: {
        value: {
          type: [Object, String],
          required: false,
        },
        name: {
            type: String,
            required: false,
        },
        field_id: {
            type: [String, Number],
            required: false,
        },
        label: {
          type: String,
          required: false,
        },     
        required: {
          type: Boolean,
          required: false,
        },   
        fields: {
          type: Array,
          required: true,
        },

        fieldsError: {
          type: Object,
          required: false,
        },            

      },
  
      data() {
          return {
            cepSearch: false,
            urlCEP: 'api/components/zip/br',
            address: {
              id: this.field_id,
              name: this.name,
              label: this.label,
                fields: {
                  zipcode: '',
                  number: '',
                  publicplace: '',
                  complement: '',
                  neighborhood: '',
                  locality: '',
                  ibge: '',
                  gia: '',
                  ddd: '',
                  siafi: '',
              },
          },
            errorClass: '',
          }
      },
  
      methods: {
        getData(){
            // get cep to api
            this.$ApiService.get(`${this.urlCEP}/${this.address.fields.zipcode}`).then(response => {
                if(response.data){
                    this.address.fields.zipcode = response.data.cep;
                    this.address.fields.publicplace = response.data.logradouro;                    
                    this.address.fields.state = response.data.uf;                   
                    this.address.fields.locality = response.data.localidade;
                    this.address.fields.neighborhood = response.data.bairro;                    
                    this.address.fields.number = '';
                    this.address.fields.complement = response.data.complemento;
                    this.address.fields.ddd = response.data.ddd;
                    this.address.fields.ibge = response.data.ibge;
                    this.address.fields.gia = response.data.gia;
                    this.address.fields.siafi = response.data.siafi;

                    this.cepSearch = true;
                } 
                else {
                    this.address.fields.zipcode = '';
                    this.address.fields.publicplace = '';
                    this.address.fields.state = '';
                    this.address.fields.locality = '';
                    this.address.fields.neighborhood = '';
                    this.address.fields.number = '';
                    this.address.fields.complement = '';
                    this.address.fields.ddd = '';
                    this.address.fields.ibge = '';
                    this.address.fields.gia = '';
                    this.address.fields.siafi = '';
                    this.cepSearch = false;
                }

                

            });
            this.updateValue();
        },
        
          updateValue(event) {
              this.$emit('update:modelValue', this.address);           
          },
          forLabel() {
              //return this.label.replace(/\s/g, '').toLowerCase();
          },
      },
      
      watch: {
        address: {
          handler: function (val, oldVal) {
            this.updateValue();
          },
          deep: true
        },
      },
     
      created() {
        if(this.value){

          if(this.value?.fields?.zipcode || this.value?.zipcode){
            this.cepSearch = true;
          }           


          this.fields.forEach(field => {           

            if(this.value[field.name]){
              this.address.fields[field.name] = this.value[field.name];
            } 

            if(this.value.fields[field.name]){
              this.address.fields[field.name] = this.value.fields[field.name];
            }             

          });        
        } 

        
      },

        components: {
            MapPinIcon,
        },

  }
  </script>